import { api } from "./configs/axiosConfig"
import { defineCancelApiObject } from "./configs/axiosUtils"
import axios from "axios";
const convert = require("xml-js");
const { v4: uuidv4 } = require('uuid');

const mexicoISOString = (addMinutes = 0, baseDate = new Date()) => {
  const tz = 'America/Mexico_City';
  const now = new Date(baseDate.getTime() + Number(addMinutes || 0) * 60_000);

  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: tz,
    year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false
  }).formatToParts(now).reduce((acc, p) => (acc[p.type] = p.value, acc), {});

  const ms = now.getMilliseconds();
  const y  = +parts.year, m = +parts.month, d = +parts.day;
  const hh = +parts.hour,  mm = +parts.minute, ss = +parts.second;
  return new Date(Date.UTC(y, m - 1, d, hh, mm, ss, ms)).toISOString();
};

export const dataApi = {
  deleteProduct: async function (index) {
    try {
      const resp = await axios.delete(`/api/products/${index}`);
      return resp.data; // updated array
    } catch (err) {
      console.error('Error deleting product:', err);
      return null;
    }
  },
  // Product CMS API (shared for all users)
  getProducts: async function () {
    // Replace with your backend API endpoint
    try {
      const resp = await axios.get('/api/products');
      return resp.data; // Should be an array of products
    } catch (err) {
      console.error('Error fetching products:', err);
      return [];
    }
  },

  addProduct: async function (product) {
    // Replace with your backend API endpoint
    try {
      const resp = await axios.post('/api/products', product);
      return resp.data; // Should be the updated array or the new product
    } catch (err) {
      console.error('Error adding product:', err);
      return null;
    }
  },
  updateProduct: async function (index, product) {
    try {
      const resp = await axios.put(`/api/products/${index}`, product);
      return resp.data;
    } catch (err) {
      console.error('Error updating product:', err);
      return null;
    }
  },
  getToken: async function (cancel = false) {
    let token = "";
    let isSuccess = true;
    let error = "";
    let UserName = "";
    let UserID = "";
    const soapURL = '/Identity/IdentityManagementService.svc?singleWSDL';
    // XML de la solicitud SOAP
    const soapRequest = `
      <Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/">
      <Body>
          <ValidateUserCredentials xmlns="http://tempuri.org/">
            <userName>${process.env.REACT_APP_USR}</userName>
            <password>${process.env.REACT_APP_PASS}</password>
          </ValidateUserCredentials>
      </Body>
      </Envelope>
    `;
    console.log(soapRequest)
    const config = {
      headers: {
        'SOAPAction': 'http://tempuri.org/IIdentityManagementService/ValidateUserCredentials',
        'Content-Type': 'text/xml; charset="utf-8"',
        'Access-Control-Allow-Headers': 'X-Requested-With, privatekey'
      },
    };
    var resp = await axios.post(soapURL, soapRequest, config, { responseType: 'document' })
      .then((response) => {
        const data = JSON.parse(
          convert.xml2json(response.data, { compact: true, spaces: 2 })
        );
        console.log(data);
        let success = data["s:Envelope"]["s:Body"].ValidateUserCredentialsResponse.ValidateUserCredentialsResult["a:IsSuccess"]._text;
        isSuccess = success;
        if (success) {
          token = data["s:Envelope"]["s:Header"]["authentication-header"].Token._text;
          UserName = data["s:Envelope"]["s:Body"].ValidateUserCredentialsResponse.ValidateUserCredentialsResult["a:Value"]["b:UserName"]._text;
          UserID = data["s:Envelope"]["s:Body"].ValidateUserCredentialsResponse.ValidateUserCredentialsResult["a:Value"]["b:UserID"]._text;
          error = "";
        } else {
          token = "";
          error = "errores locos";
        }
        return { token, isSuccess, error, UserName, UserID };
      })
      .catch((ex) => {
        error = ex;
        console.error('Error:', ex);
      });
    return resp;
  },

  //get if the kid is in the park
  GetVisitStatus: async function (token, bracelet, cancel = false) {
    let respData = {};
    let isSuccess = false;
    const soapURL = 'Operations/VisitManagementService.svc?singleWsdl';
    console.log(soapURL)
    // XML de la solicitud SOAP
    const soapRequest = `
      <Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/">
        <Header>
            <authentication-header xmlns="kidzania.com" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
              <Token xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Services.Behaviors">${token}</Token>
            </authentication-header>
        </Header>
            <Body>
                <GetVisitStatus xmlns="http://tempuri.org/">
                    <bracelate>${bracelet}</bracelate>
                    <facilityId>${process.env.REACT_APP_FACILITY_ID}</facilityId>
                </GetVisitStatus>
            </Body>
        </Envelope>
    `;
    console.log("request without card");
    console.log(soapRequest)
    const config = {
      headers: {
        'SOAPAction': 'http://tempuri.org/IVisitManagementService/GetVisitStatus',
        'Content-Type': 'text/xml; charset="utf-8"',

        'Access-Control-Allow-Headers': 'X-Requested-With, privatekey'
      },
    };
    var resp = await axios.post(soapURL, soapRequest, config, { responseType: 'document' })
      .then((response) => {
        let isInLocation = "";

        const data = JSON.parse(
          convert.xml2json(response.data, { compact: true, spaces: 2 })
        );
        console.log(data);
        const success = data["s:Envelope"]["s:Body"].GetVisitStatusResponse.GetVisitStatusResult["a:IsSuccess"]._text;
        isSuccess = success;
        console.log(isSuccess)
        if (success) {
          isInLocation = data["s:Envelope"]["s:Body"].GetVisitStatusResponse.GetVisitStatusResult["a:Value"]._text;

        }
        respData = { isInLocation, isSuccess };
      })
      .catch((error) => {
        console.error('Error:', error);
        respData = { isSuccess };
        return respData;
      });
    console.log("  getKidWithoutCard al final del consumo: " + respData);
    return respData;
  },

  getKidInfoBracelet: async function (token, visitorId, cancel = false) {
    console.log("getKidInfoBracelet ++++++++++++++++++++++++++++++++++++++++++++++++");
    let respData = {};
    const soapURL = 'Operations/EstablishmentOperationService.svc';
    let isSuccess = false;
    // XML de la solicitud SOAP
    const soapRequest = `
      <Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/">
      <Header>
      <authentication-header xmlns="kidzania.com" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
      <Token xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Services.Behaviors">${token}</Token>
      </authentication-header>
      </Header>
      <Body>
      <GetVisitorInformation xmlns="http://tempuri.org/">
      <Bracelet>${visitorId}</Bracelet>
      <FacilityID>${process.env.REACT_APP_FACILITY_ID}</FacilityID>
      </GetVisitorInformation>
      </Body>
      </Envelope>
    `;
    console.log(soapRequest)
    const config = {
      headers: {
        'SOAPAction': 'http://tempuri.org/IEstablishmentOperationService/GetVisitorInformation',
        'Content-Type': 'text/xml; charset="utf-8"',
        'Access-Control-Allow-Headers': 'X-Requested-With, privatekey'
      },
    };
    var resp = await axios.post(soapURL, soapRequest, config, { responseType: 'document' })
      .then((response) => {
        const data = JSON.parse(
          convert.xml2json(response.data, { compact: true, spaces: 2 })
        );
        const success = data["s:Envelope"]["s:Body"].GetVisitorInformationResponse.GetVisitorInformationResult["a:IsSuccess"]._text;
        isSuccess = success;
        console.log(isSuccess)
        const userData = data["s:Envelope"]["s:Body"].GetVisitorInformationResponse.GetVisitorInformationResult["a:Value"]["b:VisitName"]._text;
        respData = { userData, isSuccess };
      })
      .catch((error) => {
        console.error('Error:', error);
        respData = { isSuccess };
        return respData;
      });
    console.log("token al final del consumo: ");
    console.log(resp);
    return respData;
  },

  getKidWithoutCard: async function (token, cardNumber, cancel = false) {
    let respData = {};
    let isSuccess = false;
    const soapURL = 'Operations/BankManagementService.svc?singleWsdl';
    console.log(soapURL)
    // XML de la solicitud SOAP
    const soapRequest = `
      <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
          <soapenv:Header>
          <authentication-header xmlns="kidzania.com" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                      <Token xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Services.Behaviors">${token}</Token>
                </authentication-header>
          </soapenv:Header>
          <soapenv:Body>
            <tem:GetCardWithOutVisitor>
                <tem:cardNumber>${cardNumber}</tem:cardNumber>
            </tem:GetCardWithOutVisitor>
          </soapenv:Body>
      </soapenv:Envelope>
    `;
    console.log("request without card");
    console.log(soapRequest)
    const config = {
      headers: {
        'SOAPAction': 'http://tempuri.org/IBankManagementService/GetCardWithOutVisitor',
        'Content-Type': 'text/xml; charset="utf-8"',

        'Access-Control-Allow-Headers': 'X-Requested-With, privatekey'
      },
    };
    var resp = await axios.post(soapURL, soapRequest, config, { responseType: 'document' })
      .then((response) => {
        //data is an unformated string, data1

        let userName = "";
        let backAccountID = "";
        let VisitorID = "";
        let amount = "";
        let userId = "";
        let facility = "";
        const data = JSON.parse(
          convert.xml2json(response.data, { compact: true, spaces: 2 })
        );
        console.log("este es");
        console.log(data);
        const success = data["s:Envelope"]["s:Body"].GetCardWithOutVisitorResponse.GetCardWithOutVisitorResult["a:IsSuccess"]._text;
        isSuccess = success;
        console.log(isSuccess)
        if (success) {
          userName = data["s:Envelope"]["s:Body"].GetCardWithOutVisitorResponse.GetCardWithOutVisitorResult["a:Value"]["b:UserName"]._text;
          backAccountID = data["s:Envelope"]["s:Body"].GetCardWithOutVisitorResponse.GetCardWithOutVisitorResult["a:Value"]["b:BankAccountID"]._text;
          VisitorID = data["s:Envelope"]["s:Body"].GetCardWithOutVisitorResponse.GetCardWithOutVisitorResult["a:Value"]["b:VisitorID"]._text;
          amount = data["s:Envelope"]["s:Body"].GetCardWithOutVisitorResponse.GetCardWithOutVisitorResult["a:Value"]["b:Amount"]._text;
          userId = data["s:Envelope"]["s:Body"].GetCardWithOutVisitorResponse.GetCardWithOutVisitorResult["a:Value"]["b:UserId"]._text;
          facility = data["s:Envelope"]["s:Body"].GetCardWithOutVisitorResponse.GetCardWithOutVisitorResult["a:Value"]["b:FacilityID"]._text;
        }
        respData = { userName, backAccountID, isSuccess, VisitorID, amount, isSuccess, userId, facility };
      })
      .catch((error) => {
        console.error('Error:', error);
        respData = { isSuccess };
        return respData;
      });
    console.log("  getKidWithoutCard al final del consumo: " + respData);
    return respData;
  },

  getKidByVisitorId: async function (token, visitorId, cancel = false) {
    let isSuccess = false;
    let error = "";
    let name = "";
    let lastName = "";
    let birthdate = "";
    let establishmentI = "";
    let facility = "";
    let respData = {};
    const soapURL = '/Operations/LoyaltyManagementService.svc?singleWsdl';
    // XML de la solicitud SOAP
    const soapRequest = `
      <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">
          <soapenv:Header>
          <authentication-header xmlns="kidzania.com" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                      <Token xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Services.Behaviors">${token}</Token>
                </authentication-header>
          </soapenv:Header>
          <soapenv:Body>
            <tem:GetLoyaltyChildByVisitorID>
                <!--Optional:-->
                <tem:VisitorID>${visitorId}</tem:VisitorID>
            </tem:GetLoyaltyChildByVisitorID>
          </soapenv:Body>
      </soapenv:Envelope>
    `;
    console.log(soapRequest)
    const config = {
      headers: {
        'SOAPAction': 'http://tempuri.org/ILoyaltyManagementService/GetLoyaltyChildByVisitorID',
        'Content-Type': 'text/xml; charset="utf-8"',
        'Access-Control-Allow-Headers': 'X-Requested-With, privatekey'
      },
    };
    var resp = await axios.post(soapURL, soapRequest, config, { responseType: 'document' })
      .then((response) => {
        const data = JSON.parse(
          convert.xml2json(response.data, { compact: true, spaces: 2 })
        );
        console.log(response.data)
        console.log(data);
        isSuccess = true;
        name = data["s:Envelope"]["s:Body"].GetLoyaltyChildByVisitorIDResponse.GetLoyaltyChildByVisitorIDResult["a:FirstName"]._text;
        lastName = data["s:Envelope"]["s:Body"].GetLoyaltyChildByVisitorIDResponse.GetLoyaltyChildByVisitorIDResult["a:LastName"]._text;
        birthdate = data["s:Envelope"]["s:Body"].GetLoyaltyChildByVisitorIDResponse.GetLoyaltyChildByVisitorIDResult["a:Birthdate"]._text;
        establishmentI = data["s:Envelope"]["s:Body"].GetLoyaltyChildByVisitorIDResponse.GetLoyaltyChildByVisitorIDResult["a:EstablishmentID"]._text;
        facility = data["s:Envelope"]["s:Body"].GetLoyaltyChildByVisitorIDResponse.GetLoyaltyChildByVisitorIDResult["a:FavoriteFacilityID"]._text;
        respData = {
          name,
          lastName,
          birthdate,
          isSuccess,
          establishmentI,
          facility
        };
        return respData;
      })
      .catch((error) => {
        console.error('Error:', error);
        respData = { isSuccess };
        return respData;
      });
    console.log("token al final del consumo: " + respData);
    return respData;
  },


  getBankingData: async function (token, backAccountID, cancel = false) {
    console.log("getBankingData")
    let respData = "";
    const soapURL = 'Operations/InvestmentManagementService.svc?singleWSDL';
    console.log(soapURL)
    // XML de la solicitud SOAP
    const soapRequest = `
    <Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/">
        <Header>
            <authentication-header xmlns="kidzania.com" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
                <Token xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Services.Behaviors">${token}</Token>
            </authentication-header>
        </Header>
        <Body>
            <GetInvestmentByBankAccount xmlns="http://tempuri.org/">
                <bankAccountID>${backAccountID}</bankAccountID>
            </GetInvestmentByBankAccount>
        </Body>
    </Envelope>
    `;
    console.log(soapRequest)
    const config = {
      headers: {
        'SOAPAction': 'http://tempuri.org/IInvestmentManagementService/GetInvestmentByBankAccount',
        'Content-Type': 'text/xml; charset="utf-8"',
        'Access-Control-Allow-Headers': 'X-Requested-With, privatekey'
      },
    };
    var resp = await axios.post(soapURL, soapRequest, config, { responseType: 'document' })
      .then((response) => {
        //data is an unformated string, data1
        const data = JSON.parse(
          convert.xml2json(response.data, { compact: true, spaces: 2 })
        );
        console.log(data);


        console.log(data);

        return respData;
      })
      .catch((error) => {
        console.error('Error:', error);
        return respData;
      });
    console.log("token al final del consumo: " + respData);
    return respData;
  },
  setInvestmentTransaction: async function (token, cardNumber, cancel = false) {
    let respData = "";
    const soapURL = '/Operations/BankManagementService.svc?singleWsdl';
    console.log(process.env.REACT_APP_ESTABLISHMENT_ID);
    console.log(process.env.REACT_APP_FACILITY_ID);
    console.log(soapURL)
    // XML de la solicitud SOAP
    const soapRequest = `
    <s:Envelope xmlns:s="http://schemas.xmlsoap.org/soap/envelope/">
      <s:Header>
        <Action s:mustUnderstand="1" xmlns="http://schemas.microsoft.com/ws/2005/05/addressing/none">http://tempuri.org/IBankManagementService/CreateTransacion</Action>
      </s:Header>
      <s:Body>
        <CreateTransacion xmlns="http://tempuri.org/">
          <transaction xmlns:d4p1="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <Errors i:nil="true" xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO" />
            <d4p1:ATM i:nil="true" />
            <d4p1:ATMID i:nil="true" />
            <d4p1:Activity i:nil="true" />
            <d4p1:ActivityTransactionID i:nil="true" />
            <d4p1:Balance>0</d4p1:Balance>
            <d4p1:BankAccountID>00000000-0000-0000-0000-000000000000</d4p1:BankAccountID>
            <d4p1:BankAccountTransactionDate>0001-01-01T00:00:00</d4p1:BankAccountTransactionDate>
            <d4p1:BankAccountTransactionID>00000000-0000-0000-0000-000000000000</d4p1:BankAccountTransactionID>
            <d4p1:BankAccountTransactionType>0</d4p1:BankAccountTransactionType>
            <d4p1:Concept i:nil="true" />
            <d4p1:Establishment i:nil="true" />
            <d4p1:EstablishmentID i:nil="true" />
            <d4p1:Facility i:nil="true" />
            <d4p1:PaymentMovementID i:nil="true" />
            <d4p1:Store i:nil="true" />
            <d4p1:TransactionAmount>0</d4p1:TransactionAmount>
            <d4p1:UpdateDate>0001-01-01T00:00:00</d4p1:UpdateDate>
            <d4p1:UpdateDate2 i:nil="true" />
            <d4p1:UserId>00000000-0000-0000-0000-000000000000</d4p1:UserId>
            <d4p1:UserName i:nil="true" />
          </transaction>
        </CreateTransacion>
      </s:Body>
    </s:Envelope>
    `;
    console.log("set investment");
    console.log(soapRequest)
    const config = {
      headers: {
        'SOAPAction': 'http://tempuri.org/IBankManagementService/CreateTransacion',
        'Content-Type': 'text/xml; charset="utf-8"',
        'Access-Control-Allow-Headers': 'X-Requested-With, privatekey'
      },
    };
    var resp = await axios.post(soapURL, soapRequest, config, { responseType: 'document' })
      .then((response) => {
        //data is an unformated string, data1
        const data = JSON.parse(
          convert.xml2json(response.data, { compact: true, spaces: 2 })
        );
        console.log(data);

        console.log("valor del token en axios post: " + respData);
        return token;
      })
      .catch((error) => {
        console.error('Error:', error);
        return respData;
      });
    console.log("token al final del consumo: " + respData);
    return respData;
  },
  CreateTransaction: async function (token, amount, userName, backAccountID, userId, establishmentID, facility, tiempo = 20, cancel = false) {
    console.log("CREANDO TRANS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
    console.log(tiempo);
    let isSuccess = false;
    let error = "";
    let BankAccountTransactionID = "";
    const currentDate = new Date();
    const formattedDate = mexicoISOString();
    let respData = {};
    const soapURL = '/Operations/BankManagementService.svc?singleWSDL';
    console.log(process.env.REACT_APP_ESTABLISHMENT_ID);
    console.log(process.env.REACT_APP_FACILITY_ID);
    console.log(soapURL)
    // XML de la solicitud SOAP mexicoISOString(parseInt(tiempo))
    const soapRequest = `
    <Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/">
    <Header>
        <authentication-header xmlns="kidzania.com" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <Token xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Services.Behaviors">${token}</Token>
        </authentication-header>
    </Header>
    <Body>
        <CreateTransacion xmlns="http://tempuri.org/">
        <transaction>
          <Errors xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO">true</Errors>
          <BankAccountID xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${backAccountID}</BankAccountID>
          <BankAccountTransactionDate xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${formattedDate}</BankAccountTransactionDate>
          <BankAccountTransactionID xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${uuidv4()}</BankAccountTransactionID>
          <BankAccountTransactionType xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">2</BankAccountTransactionType>
          <Concept xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">Envio de Inversión ${tiempo}</Concept>
          <EstablishmentID xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${establishmentID}</EstablishmentID>
          <Facility xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${facility}</Facility>
          <TransactionAmount xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${amount}</TransactionAmount>
          <UpdateDate xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${formattedDate}</UpdateDate>
          <UserId xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${userId}</UserId>
          <UserName xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${userName}</UserName>
      </transaction>
        </CreateTransacion>
    </Body>
  </Envelope>
    `;
    console.log("Create Transaction");
    console.log(soapRequest)
    const config = {
      headers: {
        'SOAPAction': 'http://tempuri.org/IBankManagementService/CreateTransacion',
        'Content-Type': 'text/xml; charset="utf-8"',
        'Connection': 'close',
        'Access-Control-Allow-Headers': 'X-Requested-With, privatekey'
      },
    };
    var resp = await axios.post(soapURL, soapRequest, config, { responseType: 'document' })
      .then((response) => {
        //data is an unformated string, data1
        const data = JSON.parse(
          convert.xml2json(response.data, { compact: true, spaces: 2 })
        );
        console.log(data);
        const success = data["s:Envelope"]["s:Body"].CreateTransacionResponse.CreateTransacionResult["a:IsSuccess"]._text;
        isSuccess = success;
        if (isSuccess) {
          BankAccountTransactionID = data["s:Envelope"]["s:Body"].CreateTransacionResponse.CreateTransacionResult["a:Value"]["b:BankAccountTransactionID"]._text;

        }
        return respData = { isSuccess, BankAccountTransactionID };
      })
      .catch((error) => {
        console.error('Error:', error);
        return respData = { isSuccess };
      });
    console.log("token al final del consumo: " + respData);
    return respData;
  },
  InsertInvestment: async function (token, bankAccountTransactionID, InvestmentRateID, facility, userName, userId, cancel = false) {
    let isSuccess = false;
    let error = "";
    const currentDate = new Date();
    const formattedDate = mexicoISOString();
    let respData = {};
    const soapURL = '/Operations/BankManagementService.svc?singleWSDL';
    console.log(process.env.REACT_APP_ESTABLISHMENT_ID);
    console.log(process.env.REACT_APP_FACILITY_ID);
    console.log(soapURL)
    // XML de la solicitud SOAP
    const soapRequest = `
    <Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/">
    <Header>
        <authentication-header xmlns="kidzania.com" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <Token xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Services.Behaviors">${token}</Token>
        </authentication-header>
    </Header>
    <Body>
        <InsertInvestment xmlns="http://tempuri.org/">
            <!-- Optional -->
            <investment>
                <Errors xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO">[string?]</Errors>
                <BankAccountTransactionID xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${bankAccountTransactionID}</BankAccountTransactionID>
                <FacilityID xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${facility}</FacilityID>
                <InvestmentDate xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${formattedDate}</InvestmentDate>
                <InvestmentID xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${uuidv4()}</InvestmentID>
                <InvestmentRateID xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${InvestmentRateID}</InvestmentRateID>
                <IsActive xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">true</IsActive>
                <UpdateDate xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${formattedDate}</UpdateDate>
                <UserId xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${userId}</UserId>
                <UserName xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Entities.DTO.Operations.Bank">${userName}</UserName>
            </investment>
        </InsertInvestment>
    </Body>
</Envelope>
    `;

    console.log("Set Investment");
    console.log(soapRequest)
    const config = {
      headers: {
        'SOAPAction': 'http://tempuri.org/IBankManagementService/InsertInvestment',
        'Content-Type': 'text/xml; charset="utf-8"',
        'Connection': 'close',
        'Access-Control-Allow-Headers': 'X-Requested-With, privatekey'
      },
    };
    var resp = await axios.post(soapURL, soapRequest, config, { responseType: 'document' })
      .then((response) => {
        //data is an unformated string, data1
        const data = JSON.parse(
          convert.xml2json(response.data, { compact: true, spaces: 2 })
        );
        console.log(data);
        const success = data["s:Envelope"]["s:Body"].InsertInvestmentResponse.InsertInvestmentResult["a:IsSuccess"]._text;
        isSuccess = success;

        return respData = { isSuccess };
      })
      .catch((error) => {
        console.error('Error:', error);
        return respData = { isSuccess };
      });
    console.log("token al final del consumo: " + respData);
    return respData = { isSuccess };
  },
  //get if the kid is in the park
  GetTodayInvestments: async function (token, bracelet, cancel = false) {

    let respData = {};
    let isSuccess = false;
    const soapURL = 'Operations/BankManagementService.svc?singleWsdl';
    console.log(soapURL)
    console.log("FECHAS ++++++++++++++++++++++++++++++++++++++++++++++++++++");
    console.log(mexicoISOString());
    // XML de la solicitud SOAP
    const soapRequest = `
      <Envelope xmlns="http://schemas.xmlsoap.org/soap/envelope/">
        <Header>
          <authentication-header xmlns="kidzania.com" xmlns:i="http://www.w3.org/2001/XMLSchema-instance">
            <Token xmlns="http://schemas.datacontract.org/2004/07/KZoftware.Services.Behaviors">${token}</Token>
          </authentication-header>
        </Header>
        <Body>
          <GetInvestmentsDetailsByDateAndBracelet xmlns="http://tempuri.org/">
            <date>${mexicoISOString()}</date>
            <bracelet>${bracelet}</bracelet>
          </GetInvestmentsDetailsByDateAndBracelet>
        </Body>
      </Envelope>
    `;
    console.log("request without card");
    console.log(soapRequest)
    const config = {
      headers: {
        'SOAPAction': 'http://tempuri.org/IBankManagementService/GetInvestmentsDetailsByDateAndBracelet',
        'Content-Type': 'text/xml; charset="utf-8"',
      },
    };
    var resp = await axios.post(soapURL, soapRequest, config, { responseType: 'document' })
      .then((response) => {
        const data = JSON.parse(
          convert.xml2json(response.data, { compact: true, spaces: 2 })
        );
        console.log("RESPONSE +++++++++++++++++++++++++++++++++++++++++++");
        console.log(data);
        let success = data["s:Envelope"]["s:Body"].GetInvestmentsDetailsByDateAndBraceletResponse.GetInvestmentsDetailsByDateAndBraceletResult["a:IsSuccess"]._text;

        let items = data["s:Envelope"]["s:Body"]
          .GetInvestmentsDetailsByDateAndBraceletResponse
          .GetInvestmentsDetailsByDateAndBraceletResult["a:Value"]["b:BankAccountTransactionDTO"];

        const transactions = Array.isArray(items) ? items : items ? [items] : [];

        // Map each transaction to a simple object with formatted date and time
        const itemResp = transactions.map(tx => {
          const rawDate = tx["b:BankAccountTransactionDate"]?._text;
          let fecha = "";
          let horaInicio = "";
          let horaFin = "";
          let tiempoInversion = 20;
          let kidzosPlus = "";

          if (rawDate) {
            const d = new Date(rawDate);

            const day = String(d.getDate()).padStart(2, '0');
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const year = d.getFullYear();
            fecha = `${day}-${month}-${year}`;

            const hours = String(d.getHours()).padStart(2, '0');
            const minutes = String(d.getMinutes()).padStart(2, '0');
            horaInicio = `${hours}:${minutes}`;

            //Fix momentaneo para tiempo
            if (tx["b:Concept"]?._text == "Envio de Inversión 30") { tiempoInversion=30; kidzosPlus=2; }
            if (tx["b:Concept"]?._text == "Envio de Inversión 90") { tiempoInversion=90; kidzosPlus=2; }
            if (tx["b:Concept"]?._text == "Envio de Inversión 180") { tiempoInversion=180; kidzosPlus=6; }
            if (tx["b:Concept"]?._text == "Envio de Inversión 360") { tiempoInversion=360; kidzosPlus=6; }

            const dPlus20 = new Date(d);
            dPlus20.setMinutes(dPlus20.getMinutes() + tiempoInversion);

            const hours2 = String(dPlus20.getHours()).padStart(2, '0');
            const minutes2 = String(dPlus20.getMinutes()).padStart(2, '0');
            horaFin = `${hours2}:${minutes2}`;
          }
          return {
            folio: tx["b:BankAccountTransactionID"]?._text,
            fecha,
            inversionInicial: tx["b:TransactionAmount"]?._text,
            horaInicio,
            horaFin: horaFin, // Replace with correct field if available
            tiempoInversion: tiempoInversion, // Replace with correct field if available
            inversionFinal: parseInt(tx["b:TransactionAmount"]?._text) + kidzosPlus // Replace with correct field if available
          };
        });

        isSuccess = success;
        console.log(isSuccess)
        respData = { items: itemResp, isSuccess };
      })
      .catch((error) => {
        console.error('Error:', error);
        respData = { isSuccess };
        return respData;
      });
    console.log("  getKidWithoutCard al final del consumo: " + respData);
    console.log(resp);
    return respData;
  },
}

// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(dataApi)